export const envLog = () => {
    /* eslint-disable no-console -- print basic setup params */
    console.log('::: ::: :::');
    console.log('::: APP_NAME:', process.env.APP_NAME);
    console.log('::: APP_VERSION:', process.env.APP_VERSION);
    console.log('::: MODE:', process.env.MODE);
    console.log('::: NODE_ENV:', process.env.NODE_ENV);
    console.log('::: WEB_SERVICE_ENDPOINT:', process.env.WEB_SERVICE_ENDPOINT);
    console.log('::: EXPERIMENTAL_UI_FEATURES:', process.env.EXPERIMENTAL_UI_FEATURES);
    console.log('::: ::: :::');
    /* eslint-enable no-console */
};
